import { InputNumberProps } from '@app/types'

import { StyledInputNumber } from './elements'

export const InputNumber: React.FC<InputNumberProps> = (props) => <StyledInputNumber {...props} />
